import React, { CSSProperties } from 'react'
import MaterialTable from "material-table"
import { HistoricalOrder } from "../../api/models/OrderData"
import { Box } from '@material-ui/core'
import ProductsListQuote from '../../ProductsSearch/components/ProductList/ProductsListQuote'
import SupplierOrderProductsList from './SupplierOrderProductsList'

interface IProps {
    title: string,
    paging: boolean,
    orders: HistoricalOrder[],
    search: boolean
}
export const headerStyle: CSSProperties = {
    fontWeight: "bold"
}
export default function SupplierOrdersTable({ title, paging = true, orders, search }: IProps) {

    return (
        <MaterialTable
            components={{
                Container: Box,
            }}
            columns={
                [
                    {
                        title: 'Order sheet',
                        field: 'orderSheetName',
                        headerStyle
                    },
                    {
                        title: 'Order Id',
                        field: 'id',
                        headerStyle
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        headerStyle
                    },
                    {
                        title: 'Total',
                        field: 'finalPrice',
                        headerStyle
                    },
                    {
                        title: 'Delivery date',
                        field: 'deadline',
                        type: "datetime",
                        headerStyle
                    },
                ]
            }

            options={{
                paging: paging,
                search: search,
                toolbar: true,
            }}

            data={orders ? orders.map((u) => Object.assign({}, u, { finalPrice: `${u.delivery.finalPrice} ${u.delivery.currency}`, deadline: u.delivery.plannedDeliveryEnd })) : []}

            title={title}

            detailPanel={[
                {
                    tooltip: 'Show details',
                    render: rowData => {
                        return (
                            <Box p={2}>
                                <SupplierOrderProductsList items={rowData.delivery.items} currency={rowData.delivery.currency}/>
                            </Box>
                        )
                    },
                }
            ]}
        />
    )
}